<template>
    <div class="container" id="container">

        <!-- Buttin Back  -->
        <div class="btn-back">
            <button @click="goBack()" class="btn btn--white">
                <svg class="mr-2 display-table-cell" width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 0.594098V8.22252C5 8.75074 4.36135 9.01526 3.98785 8.64176L0.173647 4.82755C-0.0578822 4.59602 -0.0578822 4.2206 0.173647 3.98907L3.98785 0.174856C4.36135 -0.198674 5 0.06588 5 0.594098Z" fill="#52749C"/></svg>
                <span>Back</span>
            </button>
        </div>

        <!-- Header -->
        <div v-if="!loading && details && details.name" class="launchpad__header display-table mb-4 w-100 position-relative">
          <svg class="launchpad__header--icon display-table-cell" width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.8393 0.5625C6.19596 0.5625 0 6.8584 0 14.625C0 17.2031 0.684756 19.6182 1.87695 21.6953C2.14653 22.165 2.66022 22.4375 3.19553 22.4375H24.483C25.0184 22.4375 25.532 22.165 25.8016 21.6953C26.9938 19.6182 27.6786 17.2031 27.6786 14.625C27.6786 6.8584 21.4826 0.5625 13.8393 0.5625ZM21.6815 9.07861L16.4654 16.1455C16.7446 16.6157 16.9147 17.1606 16.9147 17.75C16.9147 18.3223 16.7523 18.8511 16.488 19.3125H11.1906C10.9263 18.8511 10.7639 18.3223 10.7639 17.75C10.7639 16.0239 12.1406 14.625 13.8393 14.625C14.1108 14.625 14.3688 14.6719 14.6197 14.7393L19.8363 7.67139C20.2198 7.15576 20.9415 7.05029 21.4514 7.43701C21.9603 7.82568 22.064 8.56055 21.6815 9.07861Z" fill="#2B4D75"/>
          </svg>
          <div class="ml-2 launchpad__header--title display-table-cell">
              <h1 v-if="details && details.name" class="m-0 header">{{details.name}}</h1>
          </div>
        </div>

        <!-- Page Body -->
        <!--  -->
        <div v-if="!loading && details" class="row no-gutters" style="margin: 0 -7.5px;">

          <div class="col-md-4" style="padding: 0 7.5px;">
            <div class="row no-gutters" style="margin: 0 -7.5px;">

              <!-- Account -->
              <div class="col-md-12" style="padding: 0 7.5px;">
                <s-card>
                  <s-card-header class="font-weight-bold"> Account </s-card-header>
                  <s-card-body v-if="details && details.id">
                    <div class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">ID</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span class="font-weight-bold">{{details.id}}</span>
                      </div>
                    </div>
                    <div :tooltip="details.name" class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Name</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span class="font-weight-bold">{{details.name}}</span>
                      </div>
                    </div>
                    <!-- <div :tooltip="JSON.parse(details.shop_info)['shop_name']" class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Shop name</span>
                      <div  class="display-table-cell text-right w-100 text-truncate ">
                        <span class="font-weight-bold">{{JSON.parse(details.shop_info)["shop_name"]}}</span>
                      </div>
                    </div> -->
                    <div class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Joined</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span class="font-weight-bold">{{fromNow(details.created_at)}}</span>
                      </div>
                    </div>
                    <!-- <div class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Charge Status</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span class="font-weight-bold" :class="details.charges_status=='active'?'text-success':''">{{details.charges_status}}</span>
                      </div>
                    </div> -->
                    <div class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Trial End</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span class="font-weight-bold">{{fromNow(details.trial_end_at)}}</span>
                      </div>
                    </div>
                    <div :tooltip="'https://m.scalify.com/s/contacts/view/'+details.mautic_id" class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Mautic Link</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <a :href="'https://m.scalify.com/s/contacts/view/'+details.mautic_id" target="_blank" class="text-truncate text-primary">https://m.scalify.com/s/contacts/view/{{details.mautic_id}}</a>
                      </div>
                    </div>
                  </s-card-body>
                  <s-card-body v-else> Loading || No Data </s-card-body>
                </s-card>
              </div>

              <!-- User  -->
              <div v-if="details && details.users && details.users.length > 0" class="col-md-12 mt-3" style="padding: 0 7.5px;">
                <s-card>
                  <s-card-header class="font-weight-bold"> User </s-card-header>
                  <s-card-body>
                    <div class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">ID</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span class="font-weight-bold">{{details.users[0].id}}</span>
                      </div>
                    </div>
                    <div :tooltip="details.users[0].name" class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Name</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span v-if="details.users[0].name" class="font-weight-bold">{{details.users[0].name}}</span>
                      </div>
                    </div>
                    <div :tooltip="details.users[0].email" class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Email</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span v-if="details.users[0].email" class="font-weight-bold">{{details.users[0].email}}</span>
                      </div>
                    </div>
                    <div v-if="details.users[0] && details.users[0].created_at" class="reviews__campaign--row display-table w-100">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Joined</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span v-if="details.users[0].created_at" class="font-weight-bold">{{fromNow(details.users[0].created_at)}}</span>
                      </div>
                    </div>
                    <div :tooltip="details.users[0].settings.agent" v-if="details.users[0] && details.users[0].settings && details.users[0].settings.agent" class="reviews__campaign--row display-table w-100">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Agent</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span v-if="details.users[0].settings.agent" class="font-weight-bold">{{details.users[0].settings.agent}}</span>
                      </div>
                    </div>
                    <div v-if="details.users[0] && details.users[0].settings && details.users[0].settings.country" class="reviews__campaign--row display-table w-100">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Country</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <div style="display: flex;">
                          <img v-if="countriesNames[details.users[0].settings.country] && countriesNames[details.users[0].settings.country] != undefined" style="width:20px;height:20px;margin: auto 0 auto auto;" class="circle" :src='"../../assets/images/flags/"+countriesNames[details.users[0].settings.country].toLowerCase().replace(/ /g,"-")+".svg"' />
                          <img v-else class="circle" style="width:20px;height:20px;margin: auto 0 auto auto;" src="../../assets/images/flags/default.svg" />
                          <p v-if="countriesNames[details.users[0].settings.country] && countriesNames[details.users[0].settings.country] != undefined" style="margin: auto 0px auto 10px;" class="text-truncate">{{countriesNames[details.users[0].settings.country]}}</p>
                          <p v-else style="margin: auto 0px auto 10px;" class="text-truncate">{{$t('globale_word.undefined')}}</p>
                        </div>
                      </div>
                    </div>
                  </s-card-body>
                  <s-card-footer>
                    <button v-if="!loadingLoginAccount" @click="loginAccount()" class="btn btn--white w-100">Log in as this user</button>
                    <button v-else class="btn btn--white w-100 disabled"><s-loader type="scalify"></s-loader></button>
                  </s-card-footer>
                </s-card>
              </div>
              <div v-else class="col-md-12 mt-3" style="padding: 0 7.5px;">
                <s-card>
                  <s-card-header class="font-weight-bold"> User </s-card-header>
                  <s-card-body > Loading || No Data </s-card-body>
                </s-card>
              </div>

              <!-- Profiles -->
              <div v-if="details && details.profiles && details.profiles.length > 0" class="col-md-12 mt-3" style="padding: 0 7.5px;">
                <s-card>
                  <s-card-header class="font-weight-bold"> Profiles </s-card-header>
                  <s-card-body v-if="details.profiles.length > 0">
                    <div v-for="(profile, indexProfile) in details.profiles" :tooltip="profile.email ? profile.email : profile.user_name" :key="indexProfile" class="reviews__campaign--row display-table w-100 mb-1">
                      <p  class="display-table-cell text-secondary pr-2" style="width: calc(100% - 133px)">{{profile.email ? profile.email : profile.user_name}}</p>
                      <button @click="revokeAccessToken(profile)" class="btn btn--danger display-table-cell px-2 mr-2 white-space-nowrap" :class="profile.access_token ? '' : 'disabled'">Revoke</button>
                      <div class="display-table-cell text-right " style="width: 133px;">
                        <button @click="copyFacebookToken(indexProfile)" class="btn btn--white white-space-nowrap" :class="profile.access_token ? '' : 'disabled'">Copy Token!</button>

                        <input style="z-index: -1;opacity: 0;position: absolute;right:0;" :id="`facebookToken${indexProfile}`" type="text" :value="profile.access_token">
                      </div>
                    </div>
                  </s-card-body>
                  <s-card-body v-else> Loading || No Data </s-card-body>
                </s-card>
              </div>

              <!-- Google Analytics -->
              <div v-if="gaAccessToken" class="col-md-12 mt-3" style="padding: 0 7.5px;">
                <s-card>
                  <s-card-header class="font-weight-bold"> Google Analytics </s-card-header>
                  <s-card-body >
                    <div class="reviews__campaign--row display-table w-100 mb-1">
                      <div class="display-table-cell text-right ">
                        <button @click="copyGAToken()" class="btn btn--white">Copy Token!</button>
                        <input style="z-index: -1;opacity: 0;position: absolute;right:0;" id="googleToken" type="text" :value="gaAccessToken">
                      </div>
                    </div>
                  </s-card-body>
                </s-card>
              </div>


              <!-- Extend Trial -->
              <div class="col-md-12 mt-3" style="padding: 0 7.5px;">
                <s-card>
                  <s-card-header class="font-weight-bold"> Extend Trial </s-card-header>
                  <s-card-body v-if="details && details.id">
                    <div class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Days to extend</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <s-input v-model="extendTrialDuration" type="number" :class="disableExtendTrial == true ? 'disabled' : ''" fieldFor="settings"></s-input>
                      </div>
                    </div>
                  </s-card-body>
                  <s-card-footer v-if="details && details.id">
                    <button v-if="disableExtendTrial == false" @click="extendThisTrial()" class="btn btn--white w-100">Extend Trial</button>
                    <button v-else class="btn btn--white w-100 disabled">Extend Trial</button>
                  </s-card-footer>
                  <s-card-body v-else> Loading || No Data </s-card-body>
                </s-card>
              </div>

              <!-- Extend Trial -->
              <div class="col-md-12 mt-3" style="padding: 0 7.5px;">
                <s-card>
                  <s-card-header class="font-weight-bold"> Change Email </s-card-header>
                  <s-card-body v-if="details && details.id">
                    <div class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">New Emaill</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <s-input v-model="newEmail" type="email" fieldFor="settings"></s-input>
                      </div>
                    </div>
                  </s-card-body>
                  <s-card-footer v-if="details && details.id">
                    <button v-if="loadindNewEmail == false" @click="changeEmail(details.id)" class="btn btn--white w-100">Send Confirmation Link</button>
                    <button v-else class="btn btn--white w-100 disabled">Send Confirmation Link</button>
                  </s-card-footer>
                  <s-card-body v-else> Loading || No Data </s-card-body>
                </s-card>
              </div>

            </div>

          </div>
          <div class="col-md-8" style="padding: 0 7.5px;">

            <!-- List Stores -->
            <div id="products-table">
              <s-card class="products-table__card border-top-0 p-0">
                <s-card-header class="font-weight-bold"> Stores </s-card-header>
                <s-card-body v-if="details && details.stores && details.stores.length > 0" class="product-table__table p-0">
                    <div class="product-table__table-container" style="overflow: auto !important; max-height: 550px;">
                        <table  class="product-table__table--table" id="myTable">
                            <thead class="product-table__table--header border-0 p-0 mb-4">
                                <!-- ID -->
                                <td class="text-truncate product-table__table--header-id">
                                    <span>ID</span>
                                </td>
                                <!-- Domain -->
                                <td class="text-truncate product-table__table--header-domain">
                                    <span>Domain</span>
                                </td>
                                <!-- Joined -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Joined</span>
                                </td>
                                <!-- Type -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Type</span>
                                </td>
                                <!-- Total Orders -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Total Orders</span>
                                </td>
                                <!-- Total Product -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Total Products</span>
                                </td>
                                <!-- Total Pages -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Total Pages</span>
                                </td>
                                <!-- Recuring Charges -->
                                <td class="text-truncate product-table__table--header-button">
                                  <span>Recuring Charges</span>
                                </td>
                                <!-- application_charges -->
                                <!-- <td class="text-truncate product-table__table--header-button">
                                  <span>Application Charges</span>
                                </td> -->
                                <!-- webhooks -->
                                <td class="text-truncate product-table__table--header-joined">
                                  <span>Webhooks</span>
                                </td>
                                <td class="text-truncate product-table__table--header-joined">
                                  <span>Offers</span>
                                </td>
                                <!-- Status -->
                                <td class="text-truncate product-table__table--header-joined">
                                  <span>Refresh Data</span>
                                </td>
                            </thead>
                            <tbody class="product-table__table--body">
                                <tr v-for="(store, storeIndex) in details.stores" :key="storeIndex" class="product-table__table--row">
                                    <!-- ID -->
                                    <td class="product-table__table--body-id">
                                      <p class="text-truncate">{{store.id}}</p>
                                    </td>
                                    <!-- Domain -->
                                    <td :tooltip-position="storeIndex==0?'right':'top'" :tooltip="store.name" class="product-table__table--body-domain">
                                      <p class="text-truncate">{{store.domain}}</p>
                                    </td>
                                    <!-- Joined -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{fromNow(store.created_at)}}</p>
                                    </td>
                                    <!-- Type -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{store.type}}</p>
                                    </td>
                                    <!-- Total Orders -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{store.order_settings && store.order_settings.length > 0 && store.order_settings[0].count ? store.order_settings[0].count : 0}}</p>
                                    </td>
                                    <!-- Total Products -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{store.product_settings && store.product_settings.length > 0 && store.product_settings[0].count ? store.product_settings[0].count : 0}}</p>
                                    </td>
                                    <!-- Total Pages -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{store.page_settings && store.page_settings.length > 0 && store.page_settings[0].count ? store.page_settings[0].count : 0}}</p>
                                    </td>
                                    <!-- Recuring Charges -->
                                    <td class="product-table__table--body-button">
                                        <button class="btn btn--primary" :class="store.aboutCharge && store.aboutCharge.recuring_charges && store.aboutCharge.recuring_charges.length > 0 ? '' : 'disabled'" @click="recuringCharges(storeIndex)"> Recuring Charges </button>
                                    </td>
                                    <!-- Application Charges -->
                                    <!-- <td class="product-table__table--body-button">
                                        <button class="btn btn--primary" :class="store.aboutCharge && store.aboutCharge.application_charges && store.aboutCharge.application_charges.length > 0 ? '' : 'disabled'" @click="applicationCharges(storeIndex)"> Application Charges </button>
                                    </td> -->
                                    <!-- Webhooks -->
                                    <td class="product-table__table--body-joined">
                                        <button class="btn btn--primary" :class="store.aboutCharge && store.aboutCharge.webhooks && store.aboutCharge.webhooks.length > 0 ? '' : 'disabled'" @click="weebooks(storeIndex)"> Webhooks </button>
                                    </td>
                                    <td class="product-table__table--body-joined">
                                        <button class="btn btn--primary" @click="showOffers(store)">{{"Products & Orders"}}</button>
                                    </td>
                                    <!-- Refresh Data -->
                                    <td class="product-table__table--body-joined">
                                        <button @click="refreshData(store.id, storeIndex)" class="btn btn--primary" :class="loadingRefreshData[storeIndex]?'disabled':''">
                                          <span v-if="!loadingRefreshData[storeIndex]">Refresh Data</span>
                                          <s-loader :isWhite="true" v-else></s-loader>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </s-card-body>
                <s-card-body v-else class="p-3 text-center font-weight-bold">
                  No Results
                </s-card-body>
              </s-card>
            </div>

            <!-- List Tasks -->
            <div id="products-table" class="mt-3">
              <s-card class="products-table__card border-top-0 p-0">
                <s-card-header class="font-weight-bold"> Tasks </s-card-header>
                <s-card-body v-if="details && details.tasks && details.tasks.length > 0" class="product-table__table p-0">
                    <div class="product-table__table-container" style="overflow: auto !important; max-height: 550px;">
                        <table  class="product-table__table--table" style="width: 840px;" id="myTable">
                            <thead class="product-table__table--header border-0 p-0 mb-4">
                                <!-- Name -->
                                <td class="text-truncate product-table__table--header-domain">
                                    <span>Name</span>
                                </td>
                                <!-- Started -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Started</span>
                                </td>
                                <!-- Status -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Status</span>
                                </td>
                                <!-- Status -->
                                <td class="text-truncate product-table__table--header-joined">
                                </td>
                            </thead>
                            <tbody class="product-table__table--body">
                                <tr v-for="(task, taskIndex) in details.tasks" :key="taskIndex" class="product-table__table--row">
                                    <!-- Name -->
                                    <td :tooltip-position="taskIndex==0?'right':'top'" :tooltip="task.name" class="product-table__table--body-domain">
                                      <p class="text-truncate">{{task.name}}</p>
                                    </td>
                                    <!-- Started -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{fromNow(task.created_at)}}</p>
                                    </td>
                                    <!-- Status -->
                                    <td class="product-table__table--body-joined">
                                      <div class="display-table w-100">
                                        <img class="display-table-cell" v-if="task.status=='Created' || task.status=='Done'" src="../../assets/images/status/success.svg" alt="">
                                        <img class="display-table-cell" v-else-if="task.status=='Failed' || task.status=='Deleted'" src="../../assets/images/status/danger.svg" alt="">
                                        <img class="display-table-cell" v-else-if="task.status=='Stopped' || task.status=='Pending'" src="../../assets/images/status/warning.svg" alt="">
                                        <img class="display-table-cell" v-else src="../../assets/images/status/secondary.svg" alt="">
                                        <p class="pl-2 text-truncate">{{task.status}}</p>
                                        <span class="pl-2 display-table-cell font-weight-sbold" >({{task.value.toFixed(0)}}%)</span>
                                      </div>
                                    </td>
                                    <!-- Button Details -->
                                    <td class="product-table__table--body-joined">
                                        <button @click="taskDetails(task.id)" class="btn btn--primary">Details</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </s-card-body>
                <s-card-body v-else class="p-3 text-center font-weight-bold">
                  No Results
                </s-card-body>
              </s-card>
            </div>

            <!-- List Subscribtion -->
            <div id="products-table" class="mt-3">
              <s-card class="products-table__card border-top-0 p-0">
                <s-card-header class="font-weight-bold"> Subscriptions </s-card-header>
                <s-card-body v-if="details && details.subscriptions && details.subscriptions.length > 0" class="product-table__table p-0">
                    <div class="product-table__table-container" style="overflow: auto !important; max-height: 550px;">
                        <table  class="product-table__table--table" id="myTable">
                            <thead class="product-table__table--header border-0 p-0 mb-4">
                                <!-- ID -->
                                <td class="text-truncate product-table__table--header-id">
                                    <span>ID</span>
                                </td>
                                <!-- Account ID -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Account ID</span>
                                </td>
                                <!-- Created at -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Created at</span>
                                </td>
                                <!-- Interval -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Interval</span>
                                </td>
                                <!-- Payement Methode -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Payment Method</span>
                                </td>
                                <!-- Price -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Price</span>
                                </td>
                                <!-- Status -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Status</span>
                                </td>
                                <!-- Subscription ID -->
                                <td class="text-truncate product-table__table--header-joined">
                                  <span>Subscription ID</span>
                                </td>
                                <!-- Charges -->
                                <td class="text-truncate product-table__table--header-button">
                                  <span>Charges</span>
                                </td>
                            </thead>
                            <tbody class="product-table__table--body">
                                <tr v-for="(subscription, storeIndex) in details.subscriptions" :key="storeIndex" class="product-table__table--row">
                                    <!-- ID -->
                                    <td class="product-table__table--body-id">
                                      <p class="text-truncate">{{subscription.id}}</p>
                                    </td>
                                    <!-- Account ID -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{subscription.account_id}}</p>
                                    </td>
                                    <!-- Created at -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{fromNow(subscription.created_at)}}</p>
                                    </td>
                                    <!-- Interval -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{subscription.interval}}</p>
                                    </td>
                                    <!-- Payement Methode -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{subscription.payment_method}}</p>
                                    </td>
                                    <!-- Price -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(subscription.price)}}</p>
                                    </td>
                                    <!-- Status -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{subscription.status}}</p>
                                    </td>
                                    <!-- Subscription ID -->
                                    <td class="product-table__table--body-joined">
                                        <p class="text-truncate">{{subscription.subscription_id}}</p>
                                    </td>
                                    <!-- Charges -->
                                    <td class="product-table__table--body-button">
                                        <button class="btn btn--primary" @click="subscriptionCharges(subscription.charges)" :class="subscription && subscription.charges && subscription.charges.length > 0 ? '' : 'disabled'"> Charges </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </s-card-body>
                <s-card-body v-else class="p-3 text-center font-weight-bold">
                  No Results
                </s-card-body>
              </s-card>
            </div>
          </div>

        </div>

        <div v-else class="text-center">
          <s-loader></s-loader>
        </div>

        <!-- Modal -->
        <div v-if="isOpened" style="background: rgba(13, 35, 62, 0.94); height: 100%; width: 100%; position: fixed; top: 0; left: 0;z-index: 13;">
          <s-card style="width: 90%; position: absolute; transform: translate(-50%,-50%); left: 50%; top: 50%;">
            <s-card-header class="font-weight-bold position-relative">
              <span>{{this.typeTable == 'recuring_charges'? 'Recuring Charges' : this.typeTable == 'application_charges' ? 'Application Charges' : typeTable == 'offers' ? 'Products & Orders' : typeTable == 'charges' ? 'Charges' :'Webhooks'}}</span>
              <svg @click="closeModale()" style="position: absolute; right: 20px; top: 50%; transform: translateY(-50%); cursor: pointer;" width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="3.53552" width="5" height="40" rx="2.5" transform="rotate(-45 0 3.53552)" fill="#C6D9FF"/>
                <rect x="3.53564" y="31.8198" width="5" height="40" rx="2.5" transform="rotate(-135 3.53564 31.8198)" fill="#C6D9FF"/>
              </svg>

            </s-card-header>
            <s-card-body class="p-3">
              <!-- Table Recuring Charges -->
              <div v-if="this.typeTable == 'recuring_charges'" id="products-table">
                <s-card class="products-table__card border-top-0 p-0">
                  <s-card-body class="product-table__table p-0">
                      <div class="product-table__table-container" style="overflow: auto !important;max-height: 450px;">
                          <div class="div-shadow-left" v-if="dataModal && dataModal.length"></div>
                          <!-- dataModal && dataModal.length &&  -->
                          <table v-if="(!loading) || showSearch" class="product-table__table--table" style="width: 1630px;" id="myTable">
                              <thead class="product-table__table--header border-0 p-0 mb-4">
                                  <!-- Account ID -->
                                  <td class="text-truncate product-table__table--header-joined">
                                      <span>ID</span>
                                  </td>
                                  <!-- Name -->
                                  <td class="text-truncate product-table__table--header-joined">
                                      <span>Name</span>
                                  </td>
                                  <!-- Price -->
                                  <td class="text-truncate product-table__table--header-joined">
                                      <span>Price</span>
                                  </td>
                                  <!-- Status -->
                                  <td class="text-truncate product-table__table--header-joined">
                                      <span>Status</span>
                                  </td>
                                  <!-- Created At -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Created At</span>
                                  </td>
                                  <!-- Updated At -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Updated At</span>
                                  </td>
                                  <!-- Activited On -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Activited On</span>
                                  </td>
                                  <!-- Cancelled On -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Cancelled On</span>
                                  </td>
                                  <!-- Trial Days -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Trial Days</span>
                                  </td>
                                  <!-- Trial Ends On -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Trial Ends On</span>
                                  </td>

                              </thead>
                              <tbody class="product-table__table--body">
                                  <tr  v-show="!loading" v-for="(data, accountIndex) in dataModal" :key="accountIndex" class="product-table__table--row w-100">
                                      <!-- Account ID -->
                                      <td  class="display-table-cell product-table__table--body-joined">
                                        <p class="text-truncate">{{data.id}}</p>
                                      </td>
                                      <!-- Name -->
                                      <td :tooltip-position="accountIndex==0?'right':'top'" :tooltip="data.name" class="display-table-cell product-table__table--body-joined">
                                        <p  class="text-truncate">{{data.name}}</p>
                                      </td>
                                      <!-- Price -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                        <p  class="text-truncate">{{data.price}}</p>
                                      </td>
                                      <!-- Status -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data.status}}</p>
                                      </td>
                                      <!-- Created On -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data.created_at?fromNow(data.created_at):''}}</p>
                                      </td>
                                      <!-- Updated On -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data.updated_at?fromNow(data.updated_at):''}}</p>
                                      </td>
                                      <!-- Activited On -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data.activated_on?fromNow(data.activated_on):''}}</p>
                                      </td>
                                      <!-- Cancelled On -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data.cancelled_on?fromNow(data.cancelled_on):''}}</p>
                                      </td>
                                      <!-- Trial Days -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data.trial_days}}</p>
                                      </td>
                                      <!-- Trial End On -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data.trial_ends_on?fromNow(data.trial_ends_on):''}}</p>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <div class="div-shadow-right" v-if="((dataModal && dataModal.length)||showSearch)"></div>
                      </div>
                  </s-card-body>
                </s-card>
              </div>

              <!-- Table Applications Charges -->
              <div v-if="this.typeTable == 'application_charges'" id="products-table">
                <s-card class="products-table__card border-top-0 p-0">
                  <s-card-body class="product-table__table p-0">
                      <div class="product-table__table-container" style="overflow: auto !important;max-height: 450px;">
                          <div class="div-shadow-left" v-if="dataModal && dataModal.length"></div>
                          <!-- dataModal && dataModal.length &&  -->
                          <table v-if="(!loading) || showSearch" class="product-table__table--table" style="width: 1630px;" id="myTable">
                              <thead class="product-table__table--header border-0 p-0 mb-4">
                                  <!-- Account ID -->
                                  <td class="text-truncate product-table__table--header-joined">
                                      <span>ID</span>
                                  </td>
                                  <!-- Name -->
                                  <td class="text-truncate product-table__table--header-joined">
                                      <span>Name</span>
                                  </td>
                                  <!-- Price -->
                                  <td class="text-truncate product-table__table--header-joined">
                                      <span>Price</span>
                                  </td>
                                  <!-- Status -->
                                  <td class="text-truncate product-table__table--header-joined">
                                      <span>Status</span>
                                  </td>
                                  <!-- Created At -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Created At</span>
                                  </td>
                                  <!-- Updated At -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Updated At</span>
                                  </td>
                                  <!-- Charge Type -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Charge Type</span>
                                  </td>

                              </thead>
                              <tbody class="product-table__table--body">
                                  <tr  v-show="!loading" v-for="(data, accountIndex) in dataModal" :key="accountIndex" class="product-table__table--row w-100">
                                      <!-- Account ID -->
                                      <td  class="display-table-cell product-table__table--body-joined">
                                        <p class="text-truncate">{{data.id}}</p>
                                      </td>
                                      <!-- Name -->
                                      <td :tooltip-position="accountIndex==0?'right':'top'" :tooltip="data.name" class="display-table-cell product-table__table--body-joined">
                                        <p  class="text-truncate">{{data.name}}</p>
                                      </td>
                                      <!-- Price -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                        <p  class="text-truncate">{{data.price}}</p>
                                      </td>
                                      <!-- Status -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data.status}}</p>
                                      </td>
                                      <!-- Created On -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data.created_at?fromNow(data.created_at):''}}</p>
                                      </td>
                                      <!-- Updated On -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data.updated_at?fromNow(data.updated_at):''}}</p>
                                      </td>
                                      <!-- Charge Type -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data.charge_type}}</p>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <div class="div-shadow-right" v-if="((dataModal && dataModal.length)||showSearch)"></div>
                      </div>
                  </s-card-body>
                </s-card>
              </div>

              <!-- Table Webhooks -->
              <div v-if="this.typeTable == 'webhooks'" id="products-table">
                <s-card class="products-table__card border-top-0 p-0">
                  <s-card-body class="product-table__table p-0">
                      <div class="product-table__table-container" style="overflow: auto !important;max-height: 450px;">
                          <div class="div-shadow-left" v-if="dataModal && dataModal.length"></div>
                          <!-- dataModal && dataModal.length &&  -->
                          <table v-if="(!loading) || showSearch" class="product-table__table--table" style="width: 1630px;" id="myTable">
                              <thead class="product-table__table--header border-0 p-0 mb-4">
                                  <!-- Account ID -->
                                  <td class="text-truncate product-table__table--header-joined">
                                      <span>ID</span>
                                  </td>
                                  <!-- Address -->
                                  <td class="text-truncate product-table__table--header-domain">
                                      <span>Address</span>
                                  </td>
                                  <!-- Topic -->
                                  <td class="text-truncate product-table__table--header-joined">
                                      <span>Topic</span>
                                  </td>
                                  <!-- Created At -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Created At</span>
                                  </td>
                                  <!-- Updated At -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Updated At</span>
                                  </td>
                                  <!-- Format -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Format</span>
                                  </td>
                                  <!-- Api Version -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Api Version</span>
                                  </td>
                              </thead>
                              <tbody class="product-table__table--body">
                                  <tr  v-show="!loading" v-for="(data, accountIndex) in dataModal" :key="accountIndex" class="product-table__table--row w-100">
                                      <!-- Account ID -->
                                      <td  class="display-table-cell product-table__table--body-joined">
                                        <p v-if="data.id != '-'" class="text-truncate">{{data.id}}</p>
                                        <button v-else-if="!loadingConnectWebhook" @click="reconnectWebhook(accountIndex, data.topic, data.shop, data.account_id, data.store_id)" class="btn btn--primary">Reconnect</button>
                                        <button v-else-if="loadingConnectWebhook" class="btn btn--primary disabled"><s-loader :isWhite="true"></s-loader></button>
                                      </td>
                                      <!-- Address -->
                                      <td :tooltip-position="accountIndex==0?'right':'top'" :tooltip="data.name" class="display-table-cell product-table__table--body-domain">
                                        <p class="text-truncate">{{data.address}}</p>
                                      </td>
                                      <!-- Topic -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                        <p  class="text-truncate">{{data.topic}}</p>
                                      </td>
                                      <!-- Created On -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                        <p class="text-truncate">{{data.created_at && data.created_at != '-' ? fromNow(data.created_at) : '-'}}</p>
                                      </td>
                                      <!-- Updated On -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                        <p class="text-truncate">{{data.updated_at && data.updated_at != '-' ? fromNow(data.updated_at) : '-'}}</p>
                                      </td>
                                      <!-- Format -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                        <p class="text-truncate">{{data.format}}</p>
                                      </td>
                                      <!-- Api Version -->
                                      <td class="display-table-cell product-table__table--body-joined">
                                        <p class="text-truncate">{{data.api_version}}</p>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <div class="div-shadow-right" v-if="((dataModal && dataModal.length)||showSearch)"></div>
                      </div>
                  </s-card-body>
                </s-card>
              </div>

              <!-- Table offers -->
              <div v-if="this.typeTable == 'offers'" id="products-table" :class="loadingOffersData || itemToHighlight ? 'border-0':''">
                <s-card v-if="!itemToHighlight && !isEditProduct" class="products-table__card border-top-0 p-0" :class="loadingOffersData ? 'border-0':''">
                  <s-card-body class="product-table__table p-0" v-if="!loadingOffersData">
                      <s-tabs align="left">
                        <s-tab-item :name="'Products ( '+listProducts.length+'/'+countProds+' )'" :selected="true">
                          <div class="product-table__table-container" style="overflow: auto !important;max-height: 450px;">
                            <!-- <div class="div-shadow-left" v-if="listProducts && listProducts.length"></div> -->
                            <s-input v-model="productSearchText" v-if="!loadingOffersData" class="border-bottom" placeholder="Search a Product" fieldFor="product"></s-input>
                            <table v-if="!loadingOffersData" class="product-table__table--table" style="width: 1630px;" id="myTableOffers">
                                <thead class="product-table__table--header border-0 p-0 mb-4">
                                    <!-- Account ID -->
                                    <td class="text-truncate product-table__table--header-joined">
                                        <span>ID</span>
                                    </td>
                                    <!-- Address -->
                                    <td class="text-truncate product-table__table--header-domain">
                                        <span>Title</span>
                                    </td>
                                    <!-- Topic -->
                                    <td class="text-truncate product-table__table--header-joined">
                                        <span>Shop</span>
                                    </td>
                                    <!-- Created At -->
                                    <td class="text-truncate product-table__table--header-trail-started">
                                        <span>Created At</span>
                                    </td>
                                    <!-- Updated At -->
                                    <td class="text-truncate product-table__table--header-trail-started">
                                        <span>Tags</span>
                                    </td>
                                    <!-- Format -->
                                    <td class="text-truncate product-table__table--header-trail-started">
                                        <span>Vendor</span>
                                    </td>
                                    <!-- Api Version -->
                                    <!-- <td class="text-truncate product-table__table--header-trail-started">
                                        <span>Visit</span>
                                    </td> -->
                                    <!-- Api Version -->
                                    <td class="text-truncate product-table__table--header-trail-started">
                                        <span>Details</span>
                                    </td>
                                </thead>
                                <tbody class="product-table__table--body" v-if="listProducts.length && !loadingSearchProducts">
                                    <tr  v-show="!loadingOffersData" v-for="(data, accountIndex) in listProducts" :key="accountIndex" class="product-table__table--row w-100">
                                        <!-- Account ID -->
                                        <td  class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data._source.id}}</p>
                                        </td>
                                        <!-- Address -->
                                        <td class="display-table-cell product-table__table--body-domain">
                                          <p  class="text-truncate">{{data._source.title}}</p>
                                        </td>
                                        <!-- Topic -->
                                        <td class="display-table-cell product-table__table--body-joined">
                                          <p  class="text-truncate">{{data._source.shop}}</p>
                                        </td>
                                        <!-- Created On -->
                                        <td class="display-table-cell product-table__table--body-joined">
                                            <p class="text-truncate">{{data._source.created_at?fromNow(data._source.created_at):''}}</p>
                                        </td>
                                        <!-- Updated On -->
                                        <td class="display-table-cell product-table__table--body-joined">
                                            <p class="text-truncate">{{data._source.tags}}</p>
                                        </td>
                                        <!-- Format -->
                                        <td class="display-table-cell product-table__table--body-joined">
                                            <p class="text-truncate">{{data._source.vendor}}</p>
                                        </td>
                                        <!-- Api Version -->
                                        <!-- <td class="display-table-cell product-table__table--body-joined">
                                            <p class="text-truncate"><button class="btn btn--primary" @click.stop="openUrl(data._source.frontend_url)">View Product</button></p>
                                        </td> -->
                                        <td class="display-table-cell product-table__table--body-joined">
                                            <p class="text-truncate"><button class="btn btn--primary" @click.stop="showDetails(data)">Details</button></p>
                                        </td>
                                    </tr>
                                    <tr :style="loadingMore.products?{pointerEvents:'none'}:{}" @click.stop="loadMoreProducts()" v-if="offersOrdersLength.products > listProducts.length && productSearchText == ''" class="product-table__table--row w-100 text-center p-2 cursor-pointer">
                                      <td>
                                        <p v-if="!loadingMore.products">Load More</p>
                                        <s-loader v-else></s-loader>
                                      </td>
                                    </tr>
                                </tbody>
                                <tbody class="product-table__table--body" v-else>
                                  <tr class="product-table__table--row w-100 text-center p-2">
                                    <td v-if="!listProducts.length && !loadingSearchProducts">
                                      <p>No Products Found</p>
                                    </td>
                                    <td v-if="loadingSearchProducts">
                                      <s-loader type="scalify"></s-loader>
                                    </td>
                                  </tr>
                                </tbody>
                            </table>
                            <!-- <div class="div-shadow-right" v-if="(listProducts && listProducts.length)"></div> -->
                          </div>
                        </s-tab-item>
                        <s-tab-item :name="'Orders ( '+listOrders.length+'/'+countOrders+' )'">
                          <div class="product-table__table-container" style="overflow: auto !important;max-height: 450px;">
                            <!-- <div class="div-shadow-left" v-if="listOrders && listOrders.length"></div> -->
                            <!-- listOrders && listOrders.length &&  -->
                            <s-input v-model="orderSearchText" v-if="!loadingOffersData" class="border-bottom" placeholder="Search an Offer" fieldFor="product"></s-input>
                            <table v-if="!loadingOffersData" class="product-table__table--table" style="width: 1630px;" id="myTableOrders">
                                <thead class="product-table__table--header border-0 p-0 mb-4">
                                    <!-- Account ID -->
                                    <td class="text-truncate product-table__table--header-joined">
                                        <span>ID</span>
                                    </td>
                                    <!-- Address -->
                                    <td class="text-truncate product-table__table--header-domain">
                                        <span>Name</span>
                                    </td>
                                    <!-- Topic -->
                                    <td class="text-truncate product-table__table--header-joined">
                                        <span>Status</span>
                                    </td>
                                    <!-- Created At -->
                                    <td class="text-truncate product-table__table--header-trail-started">
                                        <span>Created At</span>
                                    </td>
                                    <!-- Updated At -->
                                    <td class="text-truncate product-table__table--header-trail-started">
                                        <span>Shop</span>
                                    </td>
                                    <!-- Format -->
                                    <td class="text-truncate product-table__table--header-trail-started">
                                        <span>Email</span>
                                    </td>
                                    <!-- Api Version -->
                                    <td class="text-truncate product-table__table--header-trail-started">
                                        <span>Total</span>
                                    </td>
                                    <td class="text-truncate product-table__table--header-trail-started">
                                        <span>Details</span>
                                    </td>
                                </thead>
                                <tbody class="product-table__table--body" v-if="listOrders.length && !loadingSearchOrders">
                                    <tr  v-show="!loadingOffersData" v-for="(data, accountIndex) in listOrders" :key="accountIndex" class="product-table__table--row w-100">
                                        <!-- Account ID -->
                                        <td  class="display-table-cell product-table__table--body-joined">
                                          <p class="text-truncate">{{data._source.id}}</p>
                                        </td>
                                        <!-- Address -->
                                        <td class="display-table-cell product-table__table--body-domain">
                                          <p  class="text-truncate">{{data._source.name}}</p>
                                        </td>
                                        <!-- Topic -->
                                        <td class="display-table-cell product-table__table--body-joined">
                                          <p  class="text-truncate">{{data._source.financial_status}}</p>
                                        </td>
                                        <!-- Created On -->
                                        <td class="display-table-cell product-table__table--body-joined">
                                            <p class="text-truncate">{{data._source.created_at?fromNow(data._source.created_at):''}}</p>
                                        </td>
                                        <!-- Updated On -->
                                        <td class="display-table-cell product-table__table--body-joined">
                                            <p class="text-truncate">{{data._source.shop}}</p>
                                        </td>
                                        <!-- Format -->
                                        <td class="display-table-cell product-table__table--body-joined">
                                            <p class="text-truncate">{{data._source.email}}</p>
                                        </td>
                                        <!-- Api Version -->
                                        <td class="display-table-cell product-table__table--body-joined">
                                            <p class="text-truncate">{{data._source.total}}</p>
                                        </td>
                                        <td class="display-table-cell product-table__table--body-joined">
                                            <p class="text-truncate"><button class="btn btn--primary" @click.stop="showDetails(data)">Details</button></p>
                                        </td>
                                    </tr>
                                    <tr :style="loadingMore.orders?{pointerEvents:'none'}:{}" @click.stop="loadMoreOrders()" v-if="offersOrdersLength.orders > listOrders.length &&  orderSearchText==''" class="product-table__table--row w-100 text-center p-2 cursor-pointer">
                                      <td>
                                        <p v-if="!loadingMore.orders">Load More</p>
                                        <s-loader v-else></s-loader>
                                      </td>
                                    </tr>
                                </tbody>
                                <tbody class="product-table__table--body" v-else>
                                  <tr class="product-table__table--row w-100 text-center p-2">
                                    <td v-if="!listOrders.length && !loadingSearchOrders">
                                      <p>No Orders Found</p>
                                    </td>
                                    <td v-if="loadingSearchOrders">
                                      <s-loader type="scalify"></s-loader>
                                    </td>
                                  </tr>
                                </tbody>
                            </table>
                            <!-- <div class="div-shadow-right" v-if="(listOrders && listOrders.length)"></div> -->
                          </div>
                        </s-tab-item>
                      </s-tabs>
                  </s-card-body>
                  <div v-else class="p-4 text-center">
                    <s-loader type="scalify"></s-loader>
                  </div>
                </s-card>

                <s-card v-if="itemToHighlight && !isEditProduct" class="products-table__card border-top-0 p-0 border-0">
                  <div class="w-100 text-right mb-4" v-if="itemToHighlight._index !== 'orders'">
                    <button class="btn btn--primary" @click="isEditProduct = true">Edit</button>
                  </div>
                  <s-card-body class="product-table__table p-0 border border-radius">
                    <div class="product-table__table-container" style="overflow: auto !important;max-height: 450px;">
                      <!-- <div class="div-shadow-left" v-if="listProducts && listProducts.length"></div> -->
                      <table v-if="!loadingOffersData" class="product-table__table--table w-content" id="myTableOffers">
                          <thead class="product-table__table--header border-0 p-0 mb-4">
                              <!-- Account ID -->
                              <td class="text-truncate product-table__table--header-joined">
                                  <span>ID</span>
                              </td>
                              <!-- Address -->
                              <td class="text-truncate product-table__table--header-domain">
                                  <span>Type</span>
                              </td>
                              <!-- Topic -->
                              <td class="text-truncate product-table__table--header-joined">
                                  <span>JSON</span>
                              </td>
                          </thead>
                          <tbody class="product-table__table--body">
                              <tr class="product-table__table--row w-100">
                                  <!-- Account ID -->
                                  <td  class="product-table__table--body-joined vertical-align-top">
                                    <p class="text-truncate vertical-align-top">{{itemToHighlight._source.id}}</p>
                                  </td>
                                  <!-- Address -->
                                  <td class="product-table__table--body-domain vertical-align-top">
                                    <p  class="text-truncate vertical-align-top">{{itemToHighlight._source.shop ? 'Product' : 'Order'}}</p>
                                  </td>
                                  <!-- Topic -->
                                  <td class="display-table-cell product-table__table--body-joined">
                                    <pre  class="">{{JSON.stringify(itemToHighlight._source, undefined, 2)}}</pre>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                    </div>
                  </s-card-body>
                </s-card>

                <s-card v-if="itemToHighlight && isEditProduct" class="products-table__card border-top-0 p-0 border-0">
                  <s-card-body class="product-table__table p-0">
                    <div class="product-table__table-container">
                      <!-- <div class="div-shadow-left" v-if="listProducts && listProducts.length"></div> -->
                      <!-- <p>Never Falling, iam a Problem</p> -->
                      <v-jsoneditor ref="editProduct" v-model="itemToHighlight._source" :options="{mode: 'code'}" height="450px" :plus="false"  @error="onError"></v-jsoneditor>
                      <div class="w-100 text-right mt-4">
                        <button class="btn btn--primary btn--lg" @click="submitEditProduct()" :class="loadingEditProduct ? 'disabled':''">
                          <span class="display-table-cell" v-if="!loadingEditProduct">Done</span>
                          <s-loader :isWhite="true" v-else></s-loader>
                        </button>
                      </div>
                    </div>
                  </s-card-body>
                </s-card>

              </div>

              <!-- Table Charges -->
              <div v-if="this.typeTable == 'charges'" id="products-table">
                <s-card class="products-table__card border-top-0 p-0">
                  <s-card-body class="product-table__table p-0">
                      <div class="product-table__table-container" style="overflow: auto !important;max-height: 450px;">
                          <div class="div-shadow-left" v-if="dataModal && dataModal.length"></div>
                          <!-- dataModal && dataModal.length &&  -->
                          <table v-if="(!loading) || showSearch" class="product-table__table--table" style="width: 1630px;" id="myTable">
                              <thead class="product-table__table--header border-0 p-0 mb-4">
                                  <!-- ID -->
                                  <td class="text-truncate product-table__table--header-id">
                                      <span>ID</span>
                                  </td>
                                  <!-- Charge ID -->
                                  <td class="text-truncate product-table__table--header-domain">
                                      <span>Charge ID</span>
                                  </td>
                                  <!-- Start Date -->
                                  <td class="text-truncate product-table__table--header-joined">
                                      <span>Start Date</span>
                                  </td>
                                  <!-- End Date -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>End Date</span>
                                  </td>
                                  <!-- Payement Status -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Payement Status</span>
                                  </td>
                                  <!-- Payment Type -->
                                  <td class="text-truncate product-table__table--header-trail-started">
                                      <span>Payment Type</span>
                                  </td>
                              </thead>
                              <tbody class="product-table__table--body">
                                  <tr  v-show="!loading" v-for="(data, index) in dataModal" :key="index" class="product-table__table--row w-100">
                                      <!-- ID -->
                                      <td  class="display-table-cell product-table__table--body-id">
                                        <p class="text-truncate">{{data.id}}</p>
                                      </td>
                                      <!-- Charge ID -->
                                      <td class="display-table-cell product-table__table--body-domain">
                                        <p  class="text-truncate">{{data.charge_id}}</p>
                                      </td>
                                      <!-- Start Date -->
                                      <td class="display-table-cell product-table__table--body-trail-started">
                                        <p  class="text-truncate">{{data.start_date?fromNow(data.start_date):''}}</p>
                                      </td>
                                      <!-- End Date -->
                                      <td class="display-table-cell product-table__table--body-trail-started">
                                          <p class="text-truncate">{{data.end_date?fromNow(data.end_date):''}}</p>
                                      </td>
                                      <!-- Payement Status -->
                                      <td class="display-table-cell product-table__table--body-trail-started">
                                          <p class="text-truncate">{{data.payment_status}}</p>
                                      </td>
                                      <!-- Payment Type -->
                                      <td class="display-table-cell product-table__table--body-trail-started">
                                          <p class="text-truncate">{{data.payment_type}}</p>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <div class="div-shadow-right" v-if="((dataModal && dataModal.length)||showSearch)"></div>
                      </div>
                  </s-card-body>
                </s-card>
              </div>

            </s-card-body>
          </s-card>
        </div>



    </div>
</template>

<script>

import countries from "../../assets/data/coutry_codes_to_country_names.json"

import moment from 'moment';
import axios from 'axios';
import VJsoneditor from 'v-jsoneditor/src/index'

export default {

  name: 'about-store',

    components: {
      VJsoneditor
    },

    data(){
      return{
        loadindNewEmail:false,
        newEmail: '',
        countriesNames :countries,
        productSearchText:"",
        orderSearchText:"",
        loadingEditProduct:false,
        isEditProduct:false,
        details:null,
        extendTrialDuration: 0,
        disableExtendTrial: false,
        loading: false,
        loadingLoginAccount: false,
        loadingRefreshData: [],
        dataModal: [],
        typeTable: '',
        isOpened: false,
        showModalOffers:false,
        listProducts:[],
        listOrders:[],
        historyListProducts:[],
        historyListOrders:[],
        loadingOffersData:false,
        loadingSearchProducts:false,
        loadingSearchOrders:false,
        offersOrdersLength:{
          products:0,
          orders:0
        },
        offersOrdersPaging:{
          products:1,
          orders:1
        },
        loadingMore:{
          products:false,
          orders:false
        },
        itemToHighlight:null,
        countProds:0,
        countOrders:0,
        loadingConnectWebhook: false,
        gaAccessToken: null,
        loadingRevoke:false
      };
    },
    async mounted(){

      if (this.$route.params && this.$route.params.id) {
        this.loading = true;
        const getDetails = await this.accountDetails(`${this.api}/api/admin/account/${this.$route.params.id}/details`);
        console.log('getDetails: ', getDetails);
        if (getDetails && getDetails.id) {

          if (getDetails.tasks && getDetails.tasks.length > 0) {

            getDetails.tasks.map((task)=>{
              task.value = 0;
              if (task && task.actions && task.actions.length > 0) {
                let actoinValue = 100 / task.actions.length;
                let taskValue = 0;
                task.actions.map((action)=>{
                  if (action.status == 1) {
                    taskValue = taskValue + actoinValue;
                  }
                })
                task.value = taskValue;
              }
            })

          }
          this.details = getDetails;

          if (this.details && this.details.stores && this.details.stores.length > 0) {
            for (let indexStore = 0; indexStore < this.details.stores.length; indexStore++) {
              const store = this.details.stores[indexStore];
              if (store.type == "shopify") {
                const charges = await this.getData(`${this.api}/api/admin/store/${store.id}/info`);
                console.log('chargescharges: ', charges);
                if (charges) {
                  store.aboutCharge = charges;
                }else{
                  store.aboutCharge = null;
                }
              }else{
                store.aboutCharge = null;
              }
            }

            this.details.stores.map(()=>{
              this.loadingRefreshData.push(false)
            })

          }

          let isAfter = moment().isAfter(moment(this.details.trial_end_at));
          console.log('isAfter: ', isAfter);
          if (isAfter) {
            this.disableExtendTrial = true;
          }

        }

        const getGoogleAccessToken = await this.getData(`${this.api}/api/admin/account/${this.$route.params.id}/ga`);
        console.log('getGoogleAccessToken: ', getGoogleAccessToken);
        if (getGoogleAccessToken && getGoogleAccessToken.access_token) {
          this.gaAccessToken = getGoogleAccessToken.access_token;
        }
        this.loading = false;

      }

    },
    watch:{
      productSearchText(){
        if(this.productSearchText !== ""){
          this.listProducts = []
          this.loadingSearchProducts = true
          clearTimeout(window.popTimeout);
          window.popTimeout = setTimeout(async () => {
            if(this.productSearchText == ""){
              this.listProducts = [...this.historyListProducts]
              this.loadingSearchProducts = false
              return
            }
            let prods = await this.getData(`${this.api}/api/admin/es/store/${this.selectedStore.id}?index=products&keyword=${this.productSearchText}`)
            this.listProducts = [...prods.data]
            this.loadingSearchProducts = false
          },700);
        }
        else{
          this.listProducts = [...this.historyListProducts]
          this.loadingSearchProducts = false
        }
      },
      orderSearchText(){
        if(this.orderSearchText !== ""){
          this.listOrders = []
          this.loadingSearchOrders = true
          clearTimeout(window.popTimeout);
          window.popTimeout = setTimeout(async () => {
            if(this.orderSearchText == ""){
              this.listOrders = [...this.historyListOrders]
              this.loadingSearchOrders = false
              return
            }
            let orders = await this.getData(`${this.api}/api/admin/es/store/${this.selectedStore.id}?index=orders&keyword=${this.orderSearchText}`)
            this.listOrders = [...orders.data]
            this.loadingSearchOrders = false
          },700);
        }
        else{
          this.loadingSearchOrders = false
          this.listOrders = [...this.historyListOrders]
        }
      }
    },
    methods:{
      async changeEmail(account_id){
        this.loadindNewEmail = true;
        try{

          let data = {email: this.newEmail}

          const emailChanged = await this.postData(`${this.api}/api/admin/account/${account_id}/update-email`, data);
          console.log('email',emailChanged)

        }catch(error){
          console.log("erro",error)
        }
        this.loadindNewEmail = false;
      },
      async reconnectWebhook(index, topic, shop, account_id, store_id){
        this.loadingConnectWebhook = true;
        let address = null
        if (topic == "orders/delete") {
          address = `https://api.scalify.app/webhook/shopify/order/deleted?shop=${shop}&aid=${account_id}&sid=${store_id}`
        }else if (topic == "orders/create") {
          address = `https://api.scalify.app/webhook/shopify/order/created?shop=${shop}&aid=${account_id}&sid=${store_id}`
        }else if (topic == "orders/updated") {
          address = `https://api.scalify.app/webhook/shopify/order/updated?shop=${shop}&aid=${account_id}&sid=${store_id}`
        }else if (topic == "products/create") {
          address = `https://api.scalify.app/webhook/shopify/product/created?shop=${shop}&aid=${account_id}&sid=${store_id}`
        }else if (topic == "products/update") {
          address = `https://api.scalify.app/webhook/shopify/product/updated?shop=${shop}&aid=${account_id}&sid=${store_id}`
        }else if (topic == "products/delete") {
          address = `https://api.scalify.app/webhook/shopify/product/deleted?shop=${shop}&aid=${account_id}&sid=${store_id}`
        }else if (topic == "app/uninstalled") {
          address = `https://api.scalify.app/webhook/shopify/app/deleted?shop=${shop}&aid=${account_id}&sid=${store_id}`
        }

        let data = { "webhook": { "topic": topic, "address": address} }

        const webhookData = await this.postData(`${this.api}/api/admin/store/${store_id}/webhooks`, data);
        if (webhookData && webhookData.webhook) {
          this.dataModal[index] = webhookData.webhook
        }
        this.loadingConnectWebhook = false;

      },
      async submitEditProduct(){
        this.loadingEditProduct = true
        let endpoint = `${this.api}/api/admin/es/${this.itemToHighlight._id}/edit?index=products`
        let editprod = await this.postData(endpoint,{data:this.itemToHighlight._source})
        console.log("editprod",editprod)
        if(editprod && editprod.result && editprod.result == 'updated'){
          let indexProd = this.listProducts.findIndex(obj => obj._id == editprod._id)
          if(indexProd !== -1){
            this.listProducts[indexProd]._source = {...this.itemToHighlight._source}
            this.isEditProduct = false
          }
        }
        this.loadingEditProduct = false
      },
      onError() {
        console.log('error')
      },
      showDetails(obj){
        // console.log("objobjobjobj",obj)
        this.itemToHighlight = obj
      },
      async loadMoreProducts(){
        this.loadingMore.products = true
        let products = await this.getData(`${this.api}/api/admin/es/store/${this.selectedStore.id}?index=products&page=${this.offersOrdersPaging.products}&per_page=24`)
        console.log("produccccts",products)
        this.listProducts = [...this.listProducts,...products.data]
        this.historyListProducts = [...this.historyListProducts,...products.data]
        this.offersOrdersPaging.products++
        this.loadingMore.products = false
      },
      async loadMoreOrders(){
        this.loadingMore.orders = true
        let orders = await this.getData(`${this.api}/api/admin/es/store/${this.selectedStore.id}?index=orders&page=${this.offersOrdersPaging.orders}&per_page=24`)
        console.log("orderrrrrs",orders)
        this.listOrders = [...this.listOrders,...orders.data]
        this.historyListOrders = [...this.historyListOrders,...orders.data]
        this.offersOrdersPaging.orders++
        this.loadingMore.orders = false
      },
      async showOffers(store){
        console.log("storoooore",store)
        this.selectedStore = store
        this.loadingOffersData = true
        this.typeTable = "offers"
        this.isOpened = true;
        let products = await this.getData(`${this.api}/api/admin/es/store/${store.id}?index=products&page=${this.offersOrdersPaging.products}&per_page=24`)
        this.countProds = products.count
        console.log("produccccts",products)
        this.offersOrdersLength.products = products.count
        this.listProducts = [...products.data]
        this.historyListProducts = [...products.data]
        this.offersOrdersPaging.products++
        let orders = await this.getData(`${this.api}/api/admin/es/store/${store.id}?index=orders&page=${this.offersOrdersPaging.orders}&per_page=24`)
        console.log("orderrrrrs",orders)
        this.countOrders = orders.count
        this.offersOrdersLength.orders = orders.count
        this.listOrders = [...orders.data]
        this.historyListOrders = [...orders.data]
        this.offersOrdersPaging.orders++
        this.loadingOffersData = false
      },
      recuringCharges(storeIndex){
        this.dataModal = this.details.stores[storeIndex].aboutCharge.recuring_charges;
        this.typeTable = "recuring_charges"
        this.isOpened = true;
      },
      applicationCharges(storeIndex){
        this.dataModal = this.details.stores[storeIndex].aboutCharge.application_charges
        this.typeTable = "application_charges"
        this.isOpened = true;
      },
      weebooks(storeIndex){
        let listWebHooksRequired = ['app/uninstalled','orders/create','orders/updated','orders/delete','products/create','products/update','products/delete']
        this.dataModal = [];

        if (this.details && this.details.stores && this.details.stores[storeIndex] && this.details.stores[storeIndex].aboutCharge && this.details.stores[storeIndex].aboutCharge.webhooks) {

          this.details.stores[storeIndex].aboutCharge.webhooks.map((webhook)=>{

            webhook.exist = true;

            let index = listWebHooksRequired.findIndex((element) => element == webhook.topic);
            if (webhook && webhook.topic && index >= 0) {
              this.dataModal.push(webhook)
              if (webhook.address.includes('api.scalify.app') || webhook.address.includes('api-dev.scalify.app')) {
                listWebHooksRequired.splice(index,1);
              }
            }
          })

          if (listWebHooksRequired.length > 0) {

            listWebHooksRequired.map((topic)=>{
              this.dataModal.push({id:"-",api_version:"-",created_at:"-",fields:"-",format:"-",address:"-",metafield_namespaces:"-",private_metafield_namespaces:"-",topic:topic,updated_at:"-", store_id: this.details.stores[storeIndex].id, shop: this.details.stores[storeIndex].domain, account_id: this.details.id})
            })
          }
        }
        // this.dataModal = this.details.stores[storeIndex].aboutCharge.webhooks
        this.typeTable = "webhooks"
        this.isOpened = true;
      },
      subscriptionCharges(charges){
        this.dataModal = charges
        this.typeTable = "charges"
        this.isOpened = true;
      },
      closeModale(){
        if(this.isEditProduct){
          this.isEditProduct = false
          return
        }
        if(this.itemToHighlight){
          this.itemToHighlight = null
          return
        }
        this.isOpened = false;
        this.dataModal = null;
        this.typeTable = ""
        this.selectedStore = null
        this.offersOrdersLength = {
          products:0,
          orders:0
        }
        this.offersOrdersPaging = {
          products:1,
          orders:1
        }
        this.loadingMore = {
          products:false,
          orders:false
        }
        this.countProds = 0
        this.countOrders = 0
      },
      async loginAccount(){
        if(confirm("Do you really want to connect as this user?")){
          this.loadingLoginAccount = true;
          const loginUser = await this.getData(`${this.api}/api/admin/account/${this.details.id}/login-user`);
          console.log('loginUser: ', loginUser);
          if (loginUser && loginUser.link) {

            // let testLink = loginUser.link.replace('dev.scalify.app','localhost:8080')
            // console.log('testLink: ', testLink);
            window.open(loginUser.link, '_blank'); //loginUser.link
          }else{
            this.notify("error","Something went wrong, please try again")
          }
          this.loadingLoginAccount = false
        }
      },
      async revokeAccessToken(profile){
        console.log("profile",profile)
        // return
          this.loadingRevoke = true
          if (confirm("Are you sure you want to revoke this token?") == true) {
            try{
              const token = profile.access_token
              let userId = null
              if(profile.user_id){
                userId = profile.user_id
                let url = `https://graph.facebook.com/v16.0/${userId}/permissions?access_token=${token}`
                const response = await axios.delete(url)

                if (response.status == 200){
                    this.notify("success","Access token revoked successfully.")
                }else{
                    this.notify("error","Failed to revoke access token.")
                }
              }
              else{
                delete axios.defaults.headers.common["X-Scalify-Token"];
                const userData = await axios.get(`https://graph.facebook.com/v16.0/me?fields=id,name&access_token=${token}`)
                // console.log("userData",userData)
                if(userData && userData.data && userData.data.id){
                  userId = userData.data.id
                  let url = `https://graph.facebook.com/v16.0/${userId}/permissions?access_token=${token}`
                  const response = await axios.delete(url)

                  if (response.status == 200){
                      this.notify("success","Access token revoked successfully.")
                  }else{
                      this.notify("error","Failed to revoke access token.")
                  }
                }
              }
            }
            catch(err){
              console.log("Erroooor",err)
              if(err.response && err.response.data && err.response.data.error && err.response.data.error.message){
                this.notify("error",err.response.data.error.message)
              }
            }
          }
          this.loadingRevoke = false
      },
      copyFacebookToken(indexProfile){
        var copyText = document.getElementById(`facebookToken${indexProfile}`);
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        this.notify('success', "Text Successfully Copied!");
      },
      copyGAToken(){
        var copyText = document.getElementById(`googleToken`);
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        this.notify('success', "Text Successfully Copied!");
      },
      copyShopifyToken(){
        var copyText = this.$refs.shopifyToken;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        this.notify('success', "Text Successfully Copied!");
      },
      goBack(){
        console.log('this.$route.name: ', this.$route.name);
        if (this.$route.name == "account-details") {
          this.$router.push(`/`);
        }else if (this.$route.name == "tasks-account-details"){
          this.$router.push(`/tasks`);
        }
      },
      async extendThisTrial(){


        let id = this.details.id;
        const extend = await this.extendTrial(id, parseInt(this.extendTrialDuration));
        if(extend && extend.status == 'success') {
          this.notify('success', 'Successfuly');
        }

      },
      taskDetails(id){
        this.$router.push(`/account/task/${id}`);
      },
      async refreshData(storeID, index){

        if(confirm("Do you really want to refresh store data?")){
          this.loadingRefreshData[index] = true;
          this.$forceUpdate();
          let accountID = this.details.id;
          const refrech = await this.getData(`${this.api}/api/admin/account/${accountID}/store/${storeID}/refresh-data`);
          if(refrech && refrech.status == 'success') {
            this.notify('success', 'Successfuly');
          }
          this.loadingRefreshData[index] = false;
          this.$forceUpdate();
        }
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
